module.exports = __webpack_public_path__ + "img/gris-6.1456afb7.png";